export function flatMap<T>(arr: T[][]): T[] {
  return arr.reduce((acc: T[], next: T[]) => acc.concat(next), [] as T[]);
}
